import { format } from 'date-fns'

import { DATE_FORMAT } from 'constants/index'
import { SupplierActivationMilestoneDto } from 'generated/graphql'

export const percentage = (value?: number | null) => (value == null ? '—' : `${Math.round(value)}%`)

export const days = (value?: number | null) =>
  value == null ? '—' : `${Number.isInteger(value) ? value : value.toFixed(1)} days`

export const eligibleCaption = (milestone?: SupplierActivationMilestoneDto) =>
  milestone == null || milestone.headlineEligible === 0
    ? 'No driver has had long enough yet'
    : `${milestone.headlineConverted} of ${milestone.headlineEligible} eligible drivers`

export const cohortSpan = (size: number, start: string, end: string) => {
  const from = format(new Date(start), DATE_FORMAT)
  const to = format(new Date(end), DATE_FORMAT)
  const drivers = `${size.toLocaleString()} ${size === 1 ? 'driver' : 'drivers'}`

  return from === to
    ? `Cohort: ${drivers}, created on ${from}`
    : `Cohort: ${drivers}, created ${from} – ${to}`
}

export const participationCaption = (
  milestone: SupplierActivationMilestoneDto | undefined,
  cohortSize: number,
  verb: string,
) =>
  milestone == null
    ? undefined
    : `${Math.round(
        milestone.participationPercentage,
      )}% of all ${cohortSize} drivers in cohort ${verb}`
